import React from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

const { bool, node, string } = proptypes;

export const HeroPersonalizedWrapper = ({
  backgroundColor = 'white',
  children,
  isVisible = false,
  usePlaceholder = true,
}) => {
  const placeholderStyles = classNames({
    'hero-personalized__wrapper': isVisible,
    'hero-personalized__hidden': !isVisible,
  });
  const backgroundStyles = classNames({
    'hero-personalized__background': isVisible,
    'hero-personalized__hidden': !isVisible,
  });

  return (
    <div
      style={{
        position: 'relative',
        ...(!isVisible && { display: 'flex', flexDirection: 'column' })
      }}
      data-component="InnervateHero"
    >
      {usePlaceholder && <Skeleton className={placeholderStyles}><SkeletonBlock /></Skeleton>}
      <div className={backgroundStyles} style={{ backgroundColor }} />
      {children}
    </div>
  );
};

HeroPersonalizedWrapper.propTypes = {
  backgroundColor: string,
  children: node.isRequired,
  isVisible: bool,
  usePlaceholder: bool,
};
